module.exports = __webpack_public_path__ + "static/media/fair_light.d074249a.jpg";